<template>
  <v-container fluid>
    <template v-if="presentation && team">
      <PageTitle>
        <v-icon left>
          fal fa-fw {{ presentation.fa5_icon }}
        </v-icon>
        {{ presentation.name }}
        <template v-slot:buttons>
          <v-btn icon
                 color="primary"
                 rounded
                 @click.prevent="fetchData"
                 class="me-2">
            <v-icon>
              fal fa-sync
            </v-icon>
          </v-btn>
          <StatusChip :status="presentation.status"
                      class="font-weight-bold text-uppercase"
                      label>
          </StatusChip>
        </template>
      </PageTitle>

      <v-row>
        <v-col cols="12"
               sm="3"
               md="3">
          <v-card class="mb-4">
            <v-list nav
                    dense>
              <v-list-item :href="`/admin/presentations/${presentationID}`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-info
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Info
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canBeShared"
                           :href="`/admin/presentations/${presentationID}/share`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-share-alt
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Share
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="hasPages && canBeShared"
                           :href="`/admin/presentations/${presentationID}/insights`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-lightbulb
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Sharing Insights
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canBeShared"
                           :href="`/admin/presentations/${presentationID}/insights`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-chart-pie
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Sharing Dashboard
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canBeShared"
                           :to="{name: 'admin.sharing_sessions.index', params: {presentationID: presentationID}}">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-table
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Sharing Sessions
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item :href="presentation.type_url ? presentation.external_url : `/admin/presentations/${presentationID}/open`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-external-link
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    View
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/edit`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-pencil
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Edit
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/upload`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-upload
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Replace with New Version
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/thumbnail`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-image
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Change Thumbnail
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <template v-if="canEditPresentations && team.builder_enabled && presentation.settings.can_be_used_in_builder && presentation.is_slide_deck === false">
                <v-list-item :to="{name: 'admin.presentation.slides', params: {presentationID: presentationID}}">
                  <v-list-item-icon class="me-2">
                    <v-icon small>
                      fab fa-fw fa-slideshare
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Manage Slides
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'admin.presentation.slide_decks', params: {presentationID: presentationID}}">
                  <v-list-item-icon class="me-2">
                    <v-icon small>
                      fas fa-fw fa-users-class
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Custom Presentations
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <v-list-item v-if="1===2 && canEditPresentations && team.builder_enabled && presentation.settings.can_be_used_in_builder"
                           :href="`/admin/presentations/${presentationID}/slides`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-puzzle-piece
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Required Slides (Legacy)
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations && team.content_enabled"
                           :href="`/admin/presentations/${presentationID}/comments`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-comments
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Comments
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="team.transcription_enabled && presentation.type_video"
                           :href="`/admin/presentations/${presentationID}/transcription`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-closed-captioning
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Transcript
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="team.content_enabled && team.ai_enabled && canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/recommendations`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-list-ol
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Recommendations
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/files`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-copy
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Files
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/watchers`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-eye
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Watchers
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item v-if="1===2"
                           :href="`/admin/presentations/${presentationID}/dashboard`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-chart-line
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    User Dashboard
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canViewUserInsights"
                           :href="`/admin/presentations/${presentationID}/user-insights`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-lightbulb
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    User Insights
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item :href="`/admin/presentations/${presentationID}/sessions`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-table
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    User Sessions
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations"
                           :href="`/admin/presentations/${presentationID}/audit-trail`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-list
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Audit Trail
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations && team.copy_presentation_enabled"
                           :href="`/admin/presentations/${presentationID}/copy`">
                <v-list-item-icon class="me-2">
                  <v-icon small>
                    fas fa-fw fa-copy
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Copy Presentation
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="canEditPresentations && presentation.is_protected === false"
                           :href="`/admin/presentations/${presentationID}/delete`"
                           color="error">
                <v-list-item-icon class="me-2">
                  <v-icon small
                          color="error">
                    fas fa-fw fa-trash
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="error--text">
                    Delete Presentation
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12"
               sm="9"
               md="9">
          <router-view :presentation="presentation"
                       @updated="fetchData">
          </router-view>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>

import PresentationToolbar from "./components/PresentationToolbar";
import PageTitle from '../../components/PageTitle.vue';
import StatusChip from '../../components/StatusChip.vue';
import userAnalyticsService from '../../../../ml/services/userAnalyticsService';
import presentationService from '../../../../ml/services/presentationService';
import {mapGetters} from 'vuex';

export default {
  components: {PageTitle, PresentationToolbar, StatusChip},
  metaInfo() {
    this.$store.commit('setTitle', this.presentation ? this.presentation.name : 'Presentation');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      busy: false,
      jobs: [],
      presentation: null,
      types: {
        'card': 'card-heading, image',
      }
    }
  },
  computed: {
    ...mapGetters([
      'canEditPresentations',
      'isAdmin',
      'isMember',
      'labels',
      'presentations',
      'presentationTypes',
      'team',
      'title',
      'user',
    ]),
    presentationID() {
      return parseInt(this.$route.params.presentationID);
    },
    hasPages() {
      return this.presentation.type_pdf
        || this.presentation.converts_to_pdf;
    },
    canBeShared() {
      return this.team.sharing_enabled
        && this.presentation.can_be_shared
    },
    canViewUserInsights() { // MLD-3475
      return userAnalyticsService.canViewUserInsights(this.user, this.team, this.presentation);
    },
    hasQueuedJobs() {
      return this.jobs.length > 0;
    },
    isProcessing() { // MLD-3034
      return this.presentation && this.presentation.is_processing;
    },

  },
  created() {
    this.fetchData(true, this.presentationID);
  },
  methods: {
    async fetchData(busy = true, presentationID) {
      this.busy = busy;

      presentationService.getJobs(presentationID)
        .then(jobs => {
          this.jobs = jobs;
        })

      presentationService.getPresentation(presentationID)
        .then(presentation => {
          this.presentation = presentation;
        })
        .finally(() => {
          this.busy = false;
        });
    }
  }
}
</script>
